// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../../../Config.bs.js";
import * as Json_encode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as Network$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as NetworkV2$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/NetworkV2.bs.js";
import * as SuspensionRepoConfig from "./SuspensionRepoConfig.bs.js";
import * as CommonRepoConfig$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/CommonRepoConfig.bs.js";
import * as PostRequestHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/helper-modules/PostRequestHelper.bs.js";

function fetchSuspensionInfo(msisdn, country) {
  var requestUrl = Config.Env.getHostName(undefined) + ("/administrators/get_suspension_history?msisdn=" + msisdn);
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SuspensionRepoConfig.SuspensionInfoResponseConverter.execute, result);
                        });
            });
}

function fetchSuspensionReasons(country) {
  var requestUrl = Config.Env.getPagKongUrl(undefined) + "/fetch_suspension_reasons";
  return NetworkV2$Catalyst.get(requestUrl, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined, /* Include */2, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(SuspensionRepoConfig.SuspensionReasonsResponseConverter.execute, result);
                        });
            });
}

function suspendPartner(msisdn, reason, comment, hours, country) {
  var payloadString = PostRequestHelper$Catalyst.getPostRequestPayload({
        hd: {
          name: "msisdn",
          value: msisdn
        },
        tl: {
          hd: {
            name: "suspension_reason",
            value: reason
          },
          tl: {
            hd: {
              name: "suspension_comment",
              value: comment
            },
            tl: {
              hd: {
                name: "suspension_duration_hrs",
                value: hours
              },
              tl: /* [] */0
            }
          }
        }
      });
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/suspend_driver";
  return Network$Catalyst.postRequestV2(requestUrl, payloadString, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CommonRepoConfig$Catalyst.PostApiResponseConverter.execute, result);
                        });
            });
}

function unsuspendPartner(msisdn, comment, country) {
  var payloadString = PostRequestHelper$Catalyst.getPostRequestPayload({
        hd: {
          name: "msisdn",
          value: msisdn
        },
        tl: {
          hd: {
            name: "unsuspension_comment",
            value: comment
          },
          tl: /* [] */0
        }
      });
  var requestUrl = Config.Env.getHostName(undefined) + "/administrators/unsuspend_driver";
  return Network$Catalyst.postRequestV2(requestUrl, payloadString, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                          return Curry._1(CommonRepoConfig$Catalyst.PostApiResponseConverter.execute, result);
                        });
            });
}

function unsuspendPartnerV2(msisdn, driverUuid, adminId, adminEmail, comment, country) {
  var payloadString = JSON.stringify(Json_encode.object_({
            hd: [
              "driver_uuid",
              driverUuid
            ],
            tl: {
              hd: [
                "adminId",
                adminId
              ],
              tl: {
                hd: [
                  "mode",
                  Json_encode.object_({
                        hd: [
                          "@type",
                          "MANUAL_MODE"
                        ],
                        tl: {
                          hd: [
                            "admin_email",
                            adminEmail
                          ],
                          tl: {
                            hd: [
                              "comment",
                              comment
                            ],
                            tl: /* [] */0
                          }
                        }
                      })
                ],
                tl: {
                  hd: [
                    "suspensionHistoryId",
                    null
                  ],
                  tl: /* [] */0
                }
              }
            }
          }));
  var requestUrl = Config.Env.getPagKongUrl(undefined) + "/un_suspend_driver";
  return Network$Catalyst.postRequestV2(requestUrl, payloadString, {
                country: CountryConfig.countryToString(country)
              }, undefined, undefined).then(function (result) {
              if (typeof result === "number" || result.TAG !== /* Success */0) {
                return Promise.resolve({
                            TAG: /* Error */1,
                            _0: /* DefaultError */{
                              _0: {
                                title: /* InternalServerError */3,
                                message: "Unsuspension failed"
                              }
                            }
                          });
              } else {
                return Promise.resolve({
                            TAG: /* Ok */0,
                            _0: SuspensionRepoConfig.decodeUnsuspendResponse(result._0, msisdn)
                          });
              }
            });
}

var SuspensionRepo = {
  fetchSuspensionInfo: fetchSuspensionInfo,
  fetchSuspensionReasons: fetchSuspensionReasons,
  suspendPartner: suspendPartner,
  unsuspendPartner: unsuspendPartner,
  unsuspendPartnerV2: unsuspendPartnerV2
};

export {
  SuspensionRepo ,
  
}
/* Config Not a pure module */
